import { useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Title } from 'components/Title';

import ThermalInvoice from './ThermalInvoice'
import { InputNumber } from 'primereact/inputnumber';
export default function PrintinvoicePage() {
	
	const [pageReady, setPageReady] = useState(true);
	    const [selectedBookingId, setSelectedBookingId] = useState(null);
	return (
		<main id="PrintinvoicePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="PrintInvoice"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="booking-selector">
                        <Card>
                        <h2>Invoice Print</h2>
                        <div className="p-field">
                            <InputNumber 
                            inputId="booking-id"
                            placeholder="Enter Booking ID"
                            onValueChange={(e) => setSelectedBookingId(e.value)}
                            value={selectedBookingId}
                            showButtons
                            buttonLayout="horizontal"
                            min={1}
                            mode="decimal"
                            />
                        </div>
                        {selectedBookingId && (
                        <Button 
                        label="Generate Invoice"
                        icon="pi pi-receipt"
                        onClick={() => generateInvoice(selectedBookingId)}
                        className="p-button-primary"
                        style={{ marginTop: '10px' }}
                        />
                        )}
                        </Card>
                    </div>
                    {selectedBookingId && <ThermalInvoice bookingId={selectedBookingId} />}
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
